import React, {useEffect, useRef, useState} from 'react';
import {UseLoader} from "../../../hooks/useLoader";
import {Toast} from "primereact/toast";
import {Dialog} from "primereact/dialog";
import PropTypes from "prop-types";
import {ContainerForm} from "../../../components/Containers/ContainerForm";
import {arrayNum, error} from "../../../shared/utils/utils";
import {
    editarDeduccionSinLiq,
    eliminarDeduccionPorAso,
    selectMaestros,
    cerrarDeduccionPorRetiro
} from "../../../api/liquidacionDeduccion.service";
import {ContainerGroupForm} from "../../../components/Containers/ContainerGroupForm";
import NumberFormat from "react-number-format";
import {confirmDialog} from "primereact/confirmdialog";
import {anios, meses} from "../../../shared/types/constantes";


export const ModalEditarDeduccionIndi = ({show, hide, fields, liquidacion}) => {
    const [handleLoad] = UseLoader();
    const toast = useRef(null);

    const [fondos, setFondos] = useState([]);
    const [terceros, setTerceros] = useState([]);

    useEffect(() => {
        selectMaestros().then(r => {
            if (r.estado === 200) {
                const data = r.data;
                setFondos(data.fondo);
                setTerceros(data.tercero);
            } else {
                toast.current?.show({severity: 'warn', summary: 'Alerta', detail: r.mensaje, life: 3000});
                return;
            }
        });
        return () => {
            setFondos([])
            setTerceros([])
        };
    }, []);

    const initParams = {
        cuentadeduccion_id: '',
        deduccioncxc_id: "",
        descripcion: "",
        num_egreso: "",
        tercero_id: "",
        valor_diferido: "",
        cant_cuotas: "",
        asociado_id: "",
        anio: "",
        mes: ""
    };
    const [field, setField] = useState(initParams);

    useEffect(() => {
        setField({
            cuentadeduccion_id: fields.cuentadeduccion_id,
            deduccioncxc_id: fields.deduccioncxc_id,
            descripcion: fields.descripcion,
            num_egreso: fields.num_egreso,
            valor_diferido: fields.valor_diferido,
            cant_cuotas: fields.cant_cuotas,
            tercero_id: fields.tercero_id,
            asociado_id: fields.asociado_id,
            anio: fields.anio,
            mes: fields.mes
        })

        return () => {
            setField(initParams)

        };
    }, [fields]);

    const onSubmit = (e) => {
        try {
            e.preventDefault();
            const liquidacione = liquidacion.length > 0 ? liquidacion[0].liquidacion_id : 0;
            if (
                field.tercero_id === ''
                || field.deduccioncxc_id === ''
                || field.cuentadeduccion_id === ''
                || field.cant_cuotas === ''
                || field.valor_diferido === ''
                || field.asociado_id === ''
                || field.anio === ''
                || field.mes === ''
            ) {
                toast.current?.show({
                    severity: 'warn',
                    summary: 'Alerta',
                    detail: "Validar campos",
                    life: 3000
                });
                return;
            }

            confirmDialog({
                message: 'Confirmación:',
                header: '¿Estas seguro?',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () => {
                    handleLoad(true)
                    const response = await editarDeduccionSinLiq({...field, liquidacion: liquidacione});
                    handleLoad(false)
                    if (response.estado !== 200) {
                        toast.current?.show({
                            severity: 'error',
                            summary: 'Alerta',
                            detail: response.mensaje,
                            life: 3000
                        });
                        return;
                    }

                    toast.current?.show({severity: 'success', summary: 'Exito', detail: response.mensaje, life: 3000});
                    setField(initParams);
                    hide()

                }
            });

        } catch (e) {
            handleLoad(false)
            console.log(e)
        }
    }

    const ondelete = (e) => {
        try {
            e.preventDefault();

            if (field.deduccioncxc_id === '') {
                toast.current?.show({
                    severity: 'warn',
                    summary: 'Alerta',
                    detail: "Validar campos",
                    life: 3000
                });
                return;
            }

            confirmDialog({
                message: 'Confirmación',
                header: '¿Estas seguro?',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () => {
                    handleLoad(true)
                    const response = await eliminarDeduccionPorAso(field);

                    handleLoad(false)
                    if (response.estado !== 200) {
                        toast.current?.show({
                            severity: 'error',
                            summary: 'Alerta',
                            detail: response.mensaje,
                            life: 3000
                        });
                        return;
                    }

                    toast.current?.show({severity: 'success', summary: 'Exito', detail: response.mensaje, life: 3000});
                    setField(initParams);
                    hide()

                }
            });

        } catch (e) {
            handleLoad(false)
            console.log(e)
        }

    }
    const periodo = arrayNum(20);

    const onCerrarRetiro = (e) => {
        try {
            e.preventDefault();

            if (field.deduccioncxc_id === '') {
                toast.current?.show({
                    severity: 'warn',
                    summary: 'Alerta',
                    detail: "Validar campos",
                    life: 3000
                });
                return;
            }

            confirmDialog({
                message: 'Esto dejará la deducción con solo el valor ya causado y eliminará las cuotas pendientes no aplicadas. ¿Estás seguro?',
                header: 'Cerrar deducción por retiro',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () => {
                    handleLoad(true)
                    const response = await cerrarDeduccionPorRetiro({deduccioncxc_id: field.deduccioncxc_id});
                    handleLoad(false)
                    if (response.estado !== 200) {
                        toast.current?.show({
                            severity: 'error',
                            summary: 'Alerta',
                            detail: response.mensaje,
                            life: 3000
                        });
                        return;
                    }

                    toast.current?.show({severity: 'success', summary: 'Exito', detail: response.mensaje, life: 3000});
                    setField(initParams);
                    hide()
                }
            });

        } catch (e) {
            handleLoad(false)
            console.log(e)
        }
    }

    const renderFooter = () => {
        return (
            <div className="flex align-items-center justify-end">
                <button
                    className="warning-color-btn btn"
                    type="button"
                    onClick={hide}
                >
                    cerrar
                </button>
            </div>

        );
    }

    return (
        <>
            <Toast ref={toast}/>
            <Dialog modal maximizable header="Editar deducción" visible={show} style={{width: '90vw'}}
                    footer={renderFooter}
                    onHide={hide}>
                <div className="md:px-4">
                    <ContainerForm>
                        <form onSubmit={onSubmit} autoComplete="false">
                            <h6 className="title-modal">
                                Editar deducciones
                            </h6>
                            <div className="row">
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="fondo"
                                    >
                                        Fondo *
                                    </label>

                                    <select
                                        className="form-input-small"
                                        value={field.cuentadeduccion_id}
                                        onChange={(e) => setField({...field, cuentadeduccion_id: e.target.value})}
                                        id="tipoDoc">
                                        <option value="">seleccione</option>
                                        {fondos.map((itm, i) => <option key={i} value={itm.id}>{itm.nombre}</option>)}
                                    </select>

                                    {error(field.cuentadeduccion_id, 'required')}
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="fondo"
                                    >
                                        Tercero *
                                    </label>

                                    <select
                                        className="form-input-small"
                                        value={field.tercero_id}
                                        onChange={(e) => setField({...field, tercero_id: e.target.value})}
                                        id="tipoDoc">
                                        <option value="">seleccione</option>
                                        {terceros.map((itm, i) => <option key={i} value={itm.id}>{itm.nombre}</option>)}
                                    </select>

                                    {error(field.tercero_id, 'required')}
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="concepto"
                                    >
                                        Concepto *
                                    </label>
                                    <textarea
                                        rows={2}
                                        value={field.descripcion}
                                        onChange={(e) => setField({...field, descripcion: e.target.value})}
                                        className="form-input-small"
                                        id="concepto">
                            </textarea>
                                    {error(field.descripcion, 'maxLength', 200)}
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="valor"
                                    >
                                        Valor *
                                    </label>
                                    <NumberFormat
                                        id="valor"
                                        thousandsGroupStyle="thousand"
                                        value={field.valor_diferido}
                                        prefix="$"
                                        displayType="input"
                                        type="text"
                                        decimalSeparator="."
                                        className="form-input-small"
                                        thousandSeparator={true}
                                        allowNegative={true}
                                        onValueChange={(e) => setField({...field, valor_diferido: e.value})}
                                    />

                                    {error(field.valor_diferido, 'required')}


                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="cuotas"
                                    >
                                        Cuotas *
                                    </label>
                                    <select name="Cuotas"
                                            className="form-input-small"
                                            value={field.cant_cuotas}
                                            onChange={(e) => setField({...field, cant_cuotas: e.target.value})}
                                            id="periodo">
                                        <option value="">Seleccione...</option>
                                        {periodo.map((p, i) => <option key={i} value={p}>{p}</option>)}
                                    </select>

                                    {error(field.cant_cuotas, 'required')}
                                    {error(field.cant_cuotas, 'maxLength', 2)}

                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="egreso"
                                    >
                                        Egreso *
                                    </label>
                                    <input
                                        type="text"
                                        value={field.num_egreso}
                                        onChange={(e) => setField({...field, num_egreso: e.target.value})}
                                        className="form-input-small"
                                        id="egreso"/>
                                    {error(field.num_egreso, 'maxLength', 30)}
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="anio"
                                    >
                                        Año *
                                    </label>
                                    <select name="anio"
                                            className="form-input-small"
                                            value={field.anio}
                                            onChange={(e) => setField({...field, anio: e.target.value})}
                                            id="anio">
                                        <option value="">...</option>
                                        {anios.map((p, i) => <option key={i} value={p}>{p}</option>)}
                                    </select>
                                    {error(field.anio, 'required')}
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="mes"
                                    >
                                        Mes *
                                    </label>
                                    <select name="mes"
                                            className="form-input-small"
                                            value={field.mes}
                                            onChange={(e) => setField({...field, mes: e.target.value})}
                                            id="mes">
                                        <option value="">...</option>
                                        {meses.map((p, i) => <option key={i} value={p.value}>{p.name}</option>)}
                                    </select>

                                    {error(field.mes, 'required')}
                                </ContainerGroupForm>
                            </div>
                            <div className="row mt-4">
                                <ContainerGroupForm width="lg:w-4/12">
                                    <button
                                        className="primary-color-btn btn w-full"
                                        type="submit"
                                    >
                                        Guardar
                                    </button>

                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <button
                                        className="danger-color-btn btn w-full"
                                        type="button"
                                        onClick={ondelete}
                                    >
                                        eliminar
                                    </button>

                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-4/12">
                                    <button className="warning-color-btn btn w-full" type="button" onClick={onCerrarRetiro}>
                                        Cerrar por pago
                                    </button>
                                </ContainerGroupForm>
                            </div>
                        </form>
                    </ContainerForm>
                </div>
            </Dialog>
        </>
    );
};

ModalEditarDeduccionIndi.propTypes = {
    show: PropTypes.bool,
    hide: PropTypes.func,
    fields: PropTypes.object
};

ModalEditarDeduccionIndi.defaultProps = {
    show: false,
};
